import { render, staticRenderFns } from "./PageActivityDetail.vue?vue&type=template&id=70903dfc"
import script from "./PageActivityDetail.vue?vue&type=script&lang=js"
export * from "./PageActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports